// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__SXeQ-","upload":"Small_upload__3wCcR","imageWrap":"Small_imageWrap__fGHHL","removeBtn":"Small_removeBtn__1nd0s"};